import styled, { css } from 'styled-components';

export const Container = styled.div<{ inline: boolean }>`
  .overview-backdrop {
    all: unset;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    z-index: 1040;
    cursor: pointer;
  }

  .overview-panel {
    position: fixed;
    top: 0;
    right: 0;
    width: 50vw;
    height: 100%;
    background: #fff;
    z-index: 1050;
    box-shadow: -4px 0 12px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
  }

  ${(props) =>
    props.inline &&
    css`
      height: 100%;

      .overview-panel {
        position: static;
        width: 100%;
        box-shadow: none;
      }
    `}

  .overview-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid #eee;
  }

  .overview-content {
    padding: 16px;
    flex: 1;
    overflow-y: auto;
  }

  .timeline {
    position: relative;
    padding-left: 5px;
    border-left: 2px solid #d1d5db;
  }

  .timeline-item {
    position: relative;
    margin-bottom: 24px;
    padding-left: 18px;
  }

  .timeline-item::before {
    content: '';
    position: absolute;
    left: -2px;
    top: 10px;

    width: 12px;
    height: 2px;

    background: #9ca3af;
  }

  .list-disc {
    list-style-type: disc;
    padding-left: 20px;
  }

  .list-disc li {
    margin-bottom: 4px;
  }

  .task-group {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .badge-overview {
    border-radius: 50%;
    width: 10px;
    height: 10px;
    padding: 0;
  }

  .btn-speak {
    border: 1px solid transparent;
    background: linear-gradient(#fff, #fff) padding-box,
      linear-gradient(90deg, #007bff, #009f79) border-box;
  }

  .span-speak {
    background: linear-gradient(90deg, #007bff, #009f79);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

export const ResumoContent = styled.div`
  font-size: 14px;
  line-height: 1.55;
  color: #374151;

  .resumo-block + .resumo-block {
    margin-top: 18px;
  }

  .resumo-title {
    margin: 0 0 8px;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: #1f2937;
  }

  .resumo-list {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .resumo-list li {
    position: relative;
    padding-left: 16px;
    margin-bottom: 6px;
  }

  .resumo-list li::before {
    content: '';
    position: absolute;
    left: 2px;
    top: 9px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #009f79;
  }

  .resumo-list strong {
    color: #1f2937;
  }
`;
